import React, { useCallback, useState, useEffect } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./components/assets/css/LiveChat.css";
import "./custom.css";


import Home from './components/pages/mobile/Home';
import Login from './components/pages/mobile/Login';
import SignUp from './components/pages/mobile/SignUp';
import Registion from './components/pages/desktop/Registion';
import MAccount from './components/pages/mobile/MAccount';
import Profile from './components/pages/mobile/Profile';
import MDeposit from './components/pages/mobile/MDeposit';
import MWithdrawal from './components/pages/mobile/MWithdrawal';
import BettingRecord from './components/pages/mobile/BettingRecord';
import TransactionRecord from './components/pages/mobile/TransactionRecord';
import TurnoverRecord from './components/pages/mobile/TurnoverRecord';
import RefrrelProgram from './components/pages/mobile/RefrrelProgram';
import ResetPassword from './components/pages/mobile/ResetPassword';
import MobileInbox from './components/pages/mobile/MobileInbox';
import VIPConvert from './components/pages/mobile/VIPConvert';
import Games from './components/pages/mobile/Games';
import GameRun from './components/pages/mobile/GameRun';
import MobilePromotion from './components/pages/mobile/MobilePromotion';
import ChatHome from './components/Chat/ChatHome';
import ChatHistory from './components/Chat/ChatHistory';
import ChatBox from './components/Chat/ChatBox';
import EXHome from './components/exchanges/EXHome';
import EXHomeVelki from './components/exchanges/EXHomeVelki';
import MatchOdds from './components/exchanges/MatchOdds';
import ExAccount from './components/exchanges/ExAccount';
import InPlay from './components/exchanges/InPlay';
import PaymentTimer from './components/pages/mobile/common/PaymentTimer';
import ForgotPassword from './components/pages/mobile/ForgotPassword';
import StoreCode from './StoreCodeComponents';
import MakePayment from './components/pages/mobile/common/MakePayment';
import Splash from './splash/Splash';
import APIS from './components/pages/mobile/common/apis';
import GoToTop from './components/common/GoTop';
import { Modal } from "react-bootstrap"; 
import Maintenance from './components/pages/mobile/common/Maintenance';
import FreeSpinPage from './free-spin/FreeSpinPage';
import NineWiket from './components/pages/mobile/NineWiket';

function App() {
	const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
	const [showContent, setShowContent] = useState(false);
	const location = useLocation();

  // ── /#/9wkt exit handler ──────────────────────────────────────────────────
  // When 9WKT game redirects back with /#/9wkt in the URL, POST exit to backend
  // then strip the hash segment so the app loads cleanly.
  useEffect(() => {
    if (window.location.href.includes('/#/9wkt')) {
      const token = localStorage.getItem('token');
      fetch(`${process.env.REACT_APP_API_URL}/api/9wkt/exit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      }).finally(() => {
        const cleanUrl = window.location.href.split('/#/9wkt')[0];
        window.location.replace(cleanUrl);
      });
    }
  }, []);

	const [globalData, setGlobalData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('error'); // 'success' | 'error' | 'info'
	const [, setBalance] = useState(0);
	const [refreshPvtData, setRefreshPvtData] = useState(false);
	const [pwaIconUrl, setPwaIconUrl] = useState(null);
	const [pwaSiteName, setPwaSiteName] = useState(null);

  // Function to show alert messages (safe: strips HTML to prevent XSS)
  const sanitizeMessage = (msg) => {
    if (!msg) return '';
    const div = document.createElement('div');
    div.innerHTML = msg;
    return div.textContent || div.innerText || '';
  };

  const showAlert = (message = false, type = 'error') => { 
    if (!message) { 
      setShowModal(false);
      setModalMessage('');
      return;
    }
    setShowModal(true);
    setModalType(type || 'error');
    setModalMessage(sanitizeMessage(message));
  };

  // Function to dynamically set the favicon
  const setFavicon = (url) => {
    if (!url) return;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = url;
  };
  const [cssLoading, setCssLoading] = useState(false);

  // Fetch favicon from server
  useEffect(() => {
    const origin = window.location.hostname.replace(/^www\./, '');
    const fetchFavicon = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/logo?origin=${encodeURIComponent(origin)}`
        );
        if (!response.ok) throw new Error("Failed to fetch logo data");
        const data = await response.json();
        const item = Array.isArray(data) ? data[0] : data;
        if (item?.favicon) {
          const faviconUrl = item.favicon.startsWith('http')
            ? item.favicon
            : `${process.env.REACT_APP_API_URL}/storage/${item.favicon}`;
          setFavicon(faviconUrl);
          // prefer logo field if available, otherwise use favicon for PWA icon
          const pwaIcon = item?.logo
            ? (item.logo.startsWith('http') ? item.logo : `${process.env.REACT_APP_API_URL}/storage/${item.logo}`)
            : faviconUrl;
          setPwaIconUrl(pwaIcon);
        }
      } catch (error) {
        console.error("Error fetching favicon:", error);
      }
    };
    fetchFavicon();
  }, []);

  // Fetch general site data
useEffect(() => {
	const fetchGeneral = async () => {
		let token = localStorage.getItem('token');
		let headers = {
			'Authorization': `Bearer ${token}`
		};
		if (!token) {
			headers = {};
		}
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/general`, {
				headers: headers
			});
			if (!response.ok) {
				throw new Error("Failed to fetch General");
			}
			const data = await response.json();
			if (data) {
				document.title = data[0].site_title;
				setPwaSiteName(data[0].site_title);
				localStorage.setItem('whatsapp', data[0].whatsapp);
				localStorage.setItem('liveChat', data[0].live_chat);
				localStorage.setItem('intercom', data[0].intercom);
				localStorage.setItem('tawkId', data[0]?.tawk_id);
			}
		} catch (error) {
			console.error("Error fetching General:", error);
		}
	};

	fetchGeneral();
}, []);

// Dynamically update the PWA manifest once site name and icon are fetched
useEffect(() => {
  if (!pwaSiteName && !pwaIconUrl) return;
  const manifestData = {
    short_name: pwaSiteName || document.title,
    name: pwaSiteName || document.title,
    start_url: '/',
    display: 'standalone',
    theme_color: '#000000',
    background_color: '#ffffff',
    icons: pwaIconUrl
      ? [
          { src: pwaIconUrl, sizes: '192x192', type: 'image/png' },
          { src: pwaIconUrl, sizes: '512x512', type: 'image/png' },
        ]
      : [],
  };
  const blob = new Blob([JSON.stringify(manifestData)], { type: 'application/json' });
  const manifestUrl = URL.createObjectURL(blob);
  let manifestLink = document.querySelector("link[rel='manifest']");
  if (!manifestLink) {
    manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    document.head.appendChild(manifestLink);
  }
  manifestLink.href = manifestUrl;
  return () => URL.revokeObjectURL(manifestUrl);
}, [pwaSiteName, pwaIconUrl]);



  const fetchBalance = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/balance`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
  
        if (response.ok) {
			const data = await response.json();
		
			localStorage.setItem('balance', data.balance);
			setBalance(data.balance);
			const balanceEl = document.querySelector('.mainBalance');
			if (balanceEl) {
				balanceEl.textContent = data.balance;
			}
        } else if (response.status === 401) {
          handleLogout();
        }
      } catch (error) {
        console.error('Error fetching balance:', error);
      }
    } else {
      console.warn('No token found in local storage.');
    }
  }, []); 
	
	

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    window.location.href = '/';
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchBalance();
      const interval = setInterval(fetchBalance, 30000);
      return () => clearInterval(interval);
    }
  }, [isLoggedIn, fetchBalance]);


  const PrivateRoute = ({ element }) => {
    return isLoggedIn ? element : <Navigate to="/login" />;
  };

  useEffect(() => {
  let extraCssLink;
  let isMounted = true; 

  const loadExtraCss = () => {
    return new Promise((resolve, reject) => {
      if (location.pathname === "/make-payment") {
        extraCssLink = document.createElement("link");
        extraCssLink.rel = "stylesheet";
        extraCssLink.href = "./extra.css";
        extraCssLink.id = "extra-css";

        extraCssLink.onload = resolve;
        extraCssLink.onerror = reject;

        document.head.appendChild(extraCssLink);
      } else {
        resolve(); 
      }
    });
  };

  const loadOtherCss = async () => {
    await import("./components/assets/css/flipclock.css");
    await import("./components/assets/css/Mobile.css");
  };

  const loadAllCss = async () => {
    setCssLoading(true);
    try {
      await Promise.all([loadExtraCss(), loadOtherCss()]);
    } catch (err) {
      console.error("CSS load error:", err);
    } finally {
      if (isMounted) {
        setCssLoading(false);
      }
    }
  };

  loadAllCss();

  return () => {
    isMounted = false;
    const existingLink = document.getElementById("extra-css");
    if (existingLink) {
      document.head.removeChild(existingLink);
    }
  };
}, [location.pathname]);

const [gtmId, setGtmId] = useState(null);

  useEffect(() => {
    const id = globalData?.general?.google_tag;
    if (!id) return;

    setGtmId(id);

    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
    }

    // ✅ ডুপ্লিকেট স্ক্রিপ্ট থাকলে remove করো
    const oldScript = document.getElementById("gtm-script");
    if (oldScript) oldScript.remove();

    
    const script = document.createElement("script");
    script.id = "gtm-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    document.head.appendChild(script);

   
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });


    // cleanup optional
    return () => {
      const s = document.getElementById("gtm-script");
      if (s) s.remove();
    };
  }, [globalData]);


	
  
  return (
    <div className="App">
    {gtmId && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
            title="gtm"
          ></iframe>
        </noscript>
      )}
       <GoToTop/>
		  <APIS setGlobalData={setGlobalData} refreshPvtData={refreshPvtData} />
       
       {/* Always render the splash on initial load - it handles its own timing/visibility */}
       <Splash onSplashComplete={() => {
        setShowContent(true);
        // Force a re-render to ensure all event handlers are properly attached
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 100);
      }}/>

       {cssLoading && (
        <Splash/>
      )}

      {/* Your app content */}
      {showContent && (
        <>
        <Routes>
          <Route
            path="/"
            element={
              globalData?.general?.site_status === 0 ? (
                <Maintenance />
              ) : (
                <Home globalData={globalData} />
              )
            }
          />
          <Route path="/signup" element={<SignUp slidersMain={globalData.sliders?.main || []}  />} />
          <Route path="/login" element={<Login />} />
          <Route path="/games" element={<Games />} />
          <Route path="/forgot-password" element={<ForgotPassword showAlert={showAlert} />} />
          <Route
            path="/account"
            element={
              <PrivateRoute
                element={
                  <MAccount
                    fetchBalance={fetchBalance}
                    userData={globalData.userData}
                    general={globalData.general || {}}          
                    sociallink={globalData.socialLinks || {}}  
                  />
                }
              />
            }
          />
		<Route path="/9wiket" element={<NineWiket />} />
          <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
          <Route path="/deposit" element={<PrivateRoute element={<MDeposit usdtRate={globalData?.general?.usdt_rate} hasEWallet={globalData.hasEWallet} userData={globalData.userData || [] } transactionData={globalData.transactions || [] } items={globalData.paymentMethods || []}  promotions={globalData.promotions?.activePromotion || []} />} />} />
          <Route path="/withdrawal" element={<PrivateRoute element={<MWithdrawal general={globalData.general} hasEWallet={globalData.hasEWallet} userData={globalData.userData || [] } transactionData={globalData.transactions || [] } items={globalData.paymentMethods || []} />} />} />
          <Route path="/betting-record" element={<PrivateRoute element={<BettingRecord />} />} />
          <Route path="/transaction-record" element={<PrivateRoute element={<TransactionRecord setRefreshPvtData={setRefreshPvtData} transactionData={globalData.transactions || [] } />} />} />
          <Route path="/turnover-record" element={<PrivateRoute element={<TurnoverRecord  turnovers={globalData.turnovers || []} />} />} />
          <Route path="/refrrel-program" element={<PrivateRoute element={<RefrrelProgram showAlert={showAlert} userData={globalData.userData} />} />} />
          <Route path="/reset-password" element={<PrivateRoute element={<ResetPassword showAlert={showAlert} />} />} />
          <Route path="/inbox" element={<PrivateRoute element={<MobileInbox />} />} />
          <Route path="/vip" element={<PrivateRoute element={<VIPConvert />} />} />
          <Route path="/gamerun" element={<PrivateRoute element={<GameRun />} />} />
          <Route path="/promotions" element={<PrivateRoute element={<MobilePromotion promotions={globalData.promotions?.allPromotions || []} />} />} />
          <Route path="/chat" element={<PrivateRoute element={<ChatHome />} />} />
          <Route path="/chat-list" element={<PrivateRoute element={<ChatHistory />} />} />
          <Route path="/chat-box/:chatId" element={<PrivateRoute element={<ChatBox />} />} />
          <Route path="/odds-view" element={<PrivateRoute element={<MatchOdds />} />} />
          <Route path="/exchange" element={<PrivateRoute element={<EXHome />} />} />
          <Route path="/velki" element={<PrivateRoute element={<EXHomeVelki />} />} />
          <Route path="/exchange-account" element={<PrivateRoute element={<ExAccount />} />} />
          <Route path="/exchange-inplay" element={<PrivateRoute element={<InPlay />} />} />
          <Route path="/payment-request" element={<PrivateRoute element={<PaymentTimer />} />} />
          <Route path="/referral_code" element={<StoreCode codeType="referral_code" />} />
          <Route path="/affiliate_code" element={<StoreCode codeType="affiliate_code" />} />
          <Route path="/agent_code" element={<StoreCode codeType="agent_code" />} />
          <Route path="/make-payment" element={<MakePayment hasEWallet={globalData.hasEWallet} userData={globalData.userData || [] } />} />
          <Route path="/free-spin" element={<FreeSpinPage />} />
          <Route path="/promotions" element={<MobilePromotion promotions={globalData.promotions?.allPromotions || []} />} />
          <Route path="/register" element={<Registion />} />
          {/* Catch-all: redirect unknown routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
		  
		<div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
				<Modal.Header closeButton>
            <Modal.Title>{modalType === 'success' ? 'Success' : modalType === 'info' ? 'Notice' : 'Error'}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{modalMessage}</div>
				</Modal.Body>
			</Modal>	  
		</div>
        </>
      )}
      
    </div>
  );
}

export default App;
